<template>
  <div style="display: inline-block">
    <span class="pointer" style="color: #409eff" @click="dialogVisible = true">
      {{ no }}
    </span>

    <el-dialog
      :title="no"
      :visible.sync="dialogVisible"
      width="1200px"
      :append-to-body="true"
      class="drill-life"
    >
      <!-- <span>这是一段信息</span> -->

      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span> -->

      <DrillLife :serialNumber="no"></DrillLife>
    </el-dialog>
  </div>
</template>

<script>
// import { hasAuth } from '../../permission';

import DrillLife from '@/views/common/drill_info/index'

export default {
  components: {
    DrillLife,
  },
  props: {
    no: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dialogVisible: false,
    }
  },
}
</script>

<style>
.drill-life .el-dialog__body {
  background: #ecf0f5;
  min-height: 300px;
}

.drill-life .el-dialog__header {
  text-align: center;
}
</style>